import { isAnyOf } from "@reduxjs/toolkit";
import { startImpersonationSession, stopImpersonationSession } from "@impersonateUser/store/actions";
import { fetchUserTerms } from "@terms/store/thunks/fetchUserTerms";
import { resetAccountFundAccessState } from "@myProfile/store/ducks";
import { fetchUserIFCsThunk } from "@myProfile/store/thunks";
import { resetSelfRemovalState } from "@selfRemoval/store/ducks";
import { GetAppListener } from "@shared/models/redux";
import { LocalStorageKeys } from "@app/constants/localStorage";

export const getImpersonationListener: GetAppListener = (addAppListener) =>
  addAppListener({
    matcher: isAnyOf(startImpersonationSession, stopImpersonationSession),
    effect: (_action, { dispatch }) => {
      localStorage.removeItem(LocalStorageKeys.LpcActiveSession);

      // Clear cached account/fund access data when impersonation changes —
      // ensures fresh data is fetched for the new user context.
      dispatch(resetAccountFundAccessState());

      dispatch(resetSelfRemovalState());

      dispatch(fetchUserTerms());

      // Re-fetch IFCs for the active user context so useProfileMenuPermissions can
      // correctly determine My Profile visibility. Identity (and the impersonatee's
      // sfdcContactId) is derived server-side via RequestService's entitledUserId
      // query param + entitlement-service's IdentityController.
      dispatch(fetchUserIFCsThunk());
    },
  });
